export const MESSAGE_CARD_CUT_MESSAGE_LENGTH = 100;
export const CREATE_CHAT_CHARACTER_COUNTER_LIMIT = 200;
